"use client";
import { getCookie } from "cookies-next/client";
import {
  getAdsAttribution,
  getAttributionStorage,
  getMeasurementAttribution,
} from "../ads-attribution-client";
import { getConsentChoice } from "../consent-client";
import { getFollowValues } from "../follow-storage";

export const getUserSignUpMetadata = () => {
  const result: {
    gcid?: string;
    uetCookie?: string;
    gclid?: string;
    utmSource?: string;
    utmKamp?: string;
    utmMedium?: string;
    country?: string;
  } = {};

  const { gcid, uetCookie, gclid, gclid_captured_at, msclkid_captured_at } = getFollowValues();
  if (gcid) {
    result.gcid = gcid;
  }
  if (uetCookie) {
    result.uetCookie = uetCookie;
  }
  if (gclid) {
    result.gclid = gclid;
  }

  try {
    const searchParams = new URLSearchParams(window.location.search);
    const utmSource = searchParams.get("utm_source");
    const utmKamp = searchParams.get("utm_kamp") || searchParams.get("utm_campaign");
    const utmMedium = searchParams.get("utm_medium");
    if (utmSource) {
      result.utmSource = utmSource;
    }
    if (utmKamp) {
      result.utmKamp = utmKamp;
    }
    if (utmMedium) {
      result.utmMedium = utmMedium;
    }
  } catch (error) {
    console.error("Could not parse search params utm");
    console.error(error);
  }

  try {
    const utmCookie = getCookie("t_utm");
    if (utmCookie) {
      const utmValues = new URLSearchParams(utmCookie);
      const utmSource = utmValues.get("utm_source");
      const utmKamp = utmValues.get("utm_kamp") || utmValues.get("utm_campaign");
      const utmMedium = utmValues.get("utm_medium");
      if (utmSource) {
        result.utmSource = utmSource;
      }
      if (utmKamp) {
        result.utmKamp = utmKamp;
      }
      if (utmMedium) {
        result.utmMedium = utmMedium;
      }
    }
  } catch (error) {
    console.error("Could not parse utm cookie");
    console.error(error);
  }

  try {
    const geoCookie = getCookie("t_geo");
    if (geoCookie) {
      result.country = geoCookie;
    }
  } catch (error) {
    console.error("Could not read geo cookie");
    console.error(error);
  }

  const attribution = getAdsAttribution();
  const stored = getAttributionStorage();
  if (stored.entry) {
    result.utmSource = stored.entry.source;
    result.utmKamp = stored.entry.campaign;
    result.utmMedium = stored.entry.medium;
  }
  // Conversion measurement is consent-independent (ROPA A5a): the paid touch is
  // handed to signup metadata in every choice state; the choice itself is
  // recorded below and no advertising storage is created by this export.
  const paid = getMeasurementAttribution().paid ?? attribution;
  const choice = getConsentChoice();
  return {
    ...result,
    ...attribution,
    gclid_captured_at,
    msclkid_captured_at,
    signupEntrySource: result.utmSource,
    signupEntryCampaign: result.utmKamp,
    signupEntryMedium: result.utmMedium,
    ...(choice ? { adsConsent: choice } : {}),
    ...(paid
      ? {
          utmSource: paid.ads_source,
          utmKamp: paid.ads_campaign,
          utmMedium: paid.ads_medium,
        }
      : {}),
  };
};
